<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
  <div
    class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3"
  >
    <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
      <i class="text-bluegray-800 pi pi-times"></i>
    </span>

    <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
      <div class="bg-teal-50 p-3 border-1 border-teal-100 border-round-lg flex align-items-center justify-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:1.25rem;height:1.25rem" aria-hidden="true">
          <path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
        </svg>
      </div>
      <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
        {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.TITLE' | translate }}
        <div class="text-sm font-normal text-600">
          {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.DESCRIPTION' | translate }}
        </div>
      </div>
    </div>

    <div *ngIf="visibleTabs().length > 1" class="tab-nav tab-nav--centered w-full">
      <button
        *ngFor="let tab of visibleTabs()"
        type="button"
        class="tab-nav__item"
        [class.tab-nav__item--active]="activeTab() === tab.value"
        (click)="activeTab.set(tab.value)"
      >
        <lucide-icon *ngIf="tab.value === 'preview'" name="eye" [size]="15"></lucide-icon>
        <lucide-icon *ngIf="tab.value === 'config'" name="settings" [size]="15"></lucide-icon>
        <span>{{ tab.label }}</span>
      </button>
    </div>
  </div>

  <!-- Preview tab -->
  <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
    <div class="flex flex-column gap-4">

      <!-- Summary cards -->
      <div class="flex flex-column gap-3">
        <div class="surface-card p-4 border-1 border-round-xl border-teal-100 flex flex-row gap-4 align-items-center">
          <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem flex-shrink-0">
            <i class="pi pi-user text-teal-700 text-lg"></i>
          </div>
          <div class="flex flex-column gap-1">
            <span class="font-medium text-500">
              {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.AGENT_NAME' | translate }}
            </span>
            <span class="text-xl font-semibold text-teal-800">{{ selectedAgent?.name || '-' }}</span>
          </div>
        </div>

        <div
          *ngIf="selectedAgent?.context"
          class="surface-card p-4 border-1 border-round-xl border-teal-100 flex flex-row gap-4 align-items-start"
        >
          <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem flex-shrink-0">
            <lucide-icon name="file-text" [size]="18" class="text-cyan-700"></lucide-icon>
          </div>
          <div class="flex flex-column gap-1 min-w-0 flex-1">
            <div class="flex align-items-center justify-content-between">
              <span class="font-medium text-500">
                {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.CONTEXT' | translate }}
              </span>
              <button
                type="button"
                class="flex align-items-center gap-1 cursor-pointer border-none bg-transparent p-0 text-teal-700 text-xs"
                (click)="contextCollapsed.set(!contextCollapsed())"
              >
                <lucide-icon
                  [name]="contextCollapsed() ? 'chevron-down' : 'chevron-up'"
                  [size]="12"
                ></lucide-icon>
                {{
                  (contextCollapsed()
                    ? 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.SHOW_MORE'
                    : 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.SHOW_LESS') | translate
                }}
              </button>
            </div>
            <span
              class="white-space-pre-wrap text-sm font-normal text-700"
              [style.display]="contextCollapsed() ? '-webkit-box' : 'block'"
              [style.-webkit-line-clamp]="contextCollapsed() ? '3' : 'unset'"
              [style.-webkit-box-orient]="contextCollapsed() ? 'vertical' : 'unset'"
              [style.overflow]="contextCollapsed() ? 'hidden' : 'visible'"
            >
              {{ selectedAgent?.context }}
            </span>
          </div>
        </div>

        <div class="surface-card p-4 border-1 border-round-xl border-teal-100 flex flex-row gap-4 align-items-center">
          <div class="bg-green-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem flex-shrink-0">
            <i class="pi pi-send text-green-700 text-lg"></i>
          </div>
          <div class="flex flex-column gap-1">
            <span class="font-medium text-500">
              {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.ALL_CONTACTS' | translate }}
            </span>
            <span class="text-xl font-semibold text-teal-800">
              {{ (allContacts()
                ? 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.YES'
                : 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.PREVIEW.NO') | translate }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Config tab -->
  <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
    <div class="flex flex-column gap-5">

      <!-- Agent selection -->
      <div class="flex flex-column gap-3">
        <div class="flex flex-column gap-1">
          <span class="font-semibold text-900">
            {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.CONFIG.AGENT_LABEL' | translate }}
          </span>
          <span class="text-sm text-500">
            {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.CONFIG.AGENT_HELP' | translate }}
          </span>
        </div>

        <p-dropdown
          [options]="agents()"
          [ngModel]="selectedAgentId()"
          (ngModelChange)="onAgentChange($event)"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.CONFIG.AGENT_PLACEHOLDER' | translate"
          [filter]="true"
          filterBy="name"
          styleClass="w-full"
        ></p-dropdown>
      </div>

      <!-- All contacts toggle -->
      <div class="flex align-items-center gap-3">
        <p-checkbox
          [ngModel]="allContacts()"
          (ngModelChange)="allContacts.set($event); onAllContactsChange()"
          [binary]="true"
          inputId="allContacts"
        ></p-checkbox>
        <label for="allContacts" class="cursor-pointer text-900">
          {{ 'DATA.MODULES.INSPECTORS.START_CHAT_CONVERSATION.CONFIG.ALL_CONTACTS_LABEL' | translate }}
        </label>
      </div>

      <p-divider></p-divider>

      <!-- Validation errors -->
      <p-messages *ngIf="errors().length > 0" severity="error">
        <ng-template pTemplate="content">
          <div class="flex flex-column gap-1">
            <div *ngFor="let error of errors()">
              {{ getErrorMessage(error) }}
            </div>
          </div>
        </ng-template>
      </p-messages>

    </div>
  </div>
</div>
